import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Divider, Form, Icon, Modal, Popover, Radio, Row } from 'antd';
import Big from 'big.js';
import './ModalApprtion.less';
import Group from '@comm/chooseGroup';
import SelectApportionObj from './SelectApportionObj';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: '',
      count: '',
      minus: 0,
      avg: 0,
    };
  }

  componentDidMount() {
    this.details = [];
    const apportion = this.props.dataItem.apportion || {};
    this.handleChange(apportion.details || this.details);
    this.setState({
      type: apportion.type,
    });
  }

  content = () => {
    return (
      <div>
        <p>非公摊：按【预算分摊】扣除预算余额和分摊预算</p>
      </div>
    );
  };

  approLabel = () => {
    return (
      <span>
        分摊类型
        <Popover placement="topLeft" content={this.content()}>
          <Icon type="question-circle" style={{ color: '1890FF' }} />
        </Popover>
      </span>
    );
  };

  handleChange = params => {
    this.details = params;
    if (params.length > 0) {
      this.setState({
        count: this.getCountSum(params),
        minus: this.getMinus(params),
        avg: this.getAvg(params),
      });
    } else {
      this.setState({
        count: '-',
        minus: '',
        avg: '-',
      });
    }
  };

  getCountSum = data => {
    const countSum = data.reduce((prev, curr) => {
      return prev + curr.count;
    }, 0);
    return countSum;
  };

  getAvg = params => {
    const { dataItem, dataInfo } = this.props;
    const price = dataItem.price || dataInfo.price || 0;
    return new Big(price || 0).div(new Big(this.getCountSum(params) || 1)).toFixed(2);
  };

  getMinus = params => {
    const { dataItem, dataInfo } = this.props;
    const price = dataItem.price || dataInfo.price || 0;
    const sum = params.reduce((prev, curr) => {
      return prev.plus(new Big(curr.price || 0));
    }, new Big(0));
    const minus = (new Big(sum) - new Big(price || 0)).toFixed(2);
    return minus;
  };

  groupChange = params => {
    this.setState({
      ...params,
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleType = e => {
    this.setState({
      type: e.target.value,
    });
  };

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;
        params.details = this.details;
        params.groupName = this.state.groupName;
        params.groupUuid = this.state.groupUuid;

        this.props.onOk(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo, visible, dataItem } = this.props;
    let { isPublic } = this.props;
    const { count, minus, avg, type } = this.state;
    const apportion = dataItem.apportion || {};
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };
    const formItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const details = apportion.details || this.details;
    if (apportion.type === 1 || apportion.type === 2) {
      isPublic = true;
    }
    return (
      <Modal
        width={900}
        title="设置分摊方案"
        visible={visible}
        onCancel={() => this.props.onCancel(false)}
        onOk={this.handleSubmit}
      >
        <Form className="modalApportion">
          <Row>
            <Col span={11}>
              <FormItem label={this.approLabel()} {...formItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请设置分摊类型!' }],
                  initialValue:
                    apportion.type === 0 || apportion.type === 1 ? `${apportion.type}` : '0',
                })(
                  <RadioGroup onChange={this.handleType}>
                    <RadioButton value="0">非公摊</RadioButton>
                    {isPublic ? <RadioButton value="1">单次公摊</RadioButton> : null}
                    {isPublic ? <RadioButton value="2">多次公摊</RadioButton> : null}
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="类型" {...formItemLayout}>
                {this.findTypeName(dataItem.type || dataInfo.type)}
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem label="金额" {...formItemLayout}>
                {dataItem.price || dataInfo.price}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={11}>
              <FormItem label="分摊人均金额" {...formItemLayout2}>
                {avg}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="分摊人数" {...formItemLayout2}>
                {count}
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem label="分摊金额" {...formItemLayout}>
                {dataInfo.price}
                {new Big(minus || 0).eq(new Big(0)) ? null : (
                  <span style={{ color: 'red', marginLeft: '8px' }}>差额{minus}元</span>
                )}
              </FormItem>
            </Col>
          </Row>
          <Divider />

          {+type === 1 || +type === 2 ? (
            <Row>
              <Col span={11}>
                <FormItem
                  label="预算来源"
                  labelCol={{ span: 5 }}
                  wrapperCol={{ span: 14 }}
                  style={{ paddingRight: '10px' }}
                >
                  {getFieldDecorator('groupUuid', {
                    rules: [{ required: true, message: '请选择预算来源!' }],
                  })(
                    <Group
                      mode=""
                      onChange={this.groupChange}
                      defaultValue={apportion.groupUuid}
                    />,
                  )}
                </FormItem>
              </Col>
            </Row>
          ) : null}
          <Row>
            {+type === 2 ? null : (
              <SelectApportionObj
                price={dataInfo.price || 0}
                onChange={this.handleChange}
                dataItem={dataItem}
                choosedArr={details}
              />
            )}
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Form.create()(ModalApportion));



// WEBPACK FOOTER //
// ./src/components/comm/apportion/ModalApportion.js